/**
 * G3.4-B — shared "now" rune for SLA labels in the widget.
 *
 * Mirror of admin-console's `inbox/now-tick.ts`. Components reading
 * `nowTick.value` inside a `$derived` get automatic re-render every
 * 60s, keeping "Waiting Xm" labels on conversation rows fresh between
 * realtime events without each component owning its own interval.
 *
 * Module-scoped interval starts once at first import and never stops.
 * The widget is a long-lived embed surface; one timer per iframe load
 * is negligible. SSR / no-setInterval contexts leave the value at the
 * initial timestamp — helpers degrade gracefully.
 */

class NowTick {
  value = $state(Date.now());
}

export const nowTick = new NowTick();

if (typeof globalThis !== 'undefined' && typeof globalThis.setInterval === 'function') {
  globalThis.setInterval(() => {
    nowTick.value = Date.now();
  }, 60_000);
}
